import { SimInventoryTable } from './Components/SimInventoryTable';
import { TableSkeleton } from 'common/components/Table/TableSkeleton';
import { SuspenseLoadingView } from 'common/components/SuspenseLoadingView';
import { SimFilters } from './Filters/SimFilters';

import { ContentBox } from 'common/components/AppLayout/ContentBox';
import { TableWithFiltersLayout } from 'common/components/AppLayout/TableWithFiltersLayout';

import { useCustomFieldsFiltersInitialization } from './Filters/hooks/useCustomFieldsFiltersInit';
import { SimProfileTagProvider } from './Tags/SimProfileTagProvider';
import { SimInventoryFiltersURLParser } from './Filters/SearchParams/SimInventoryFiltersURLParser';
import { SimProfilesPageLayout } from './layout/SimProfilesPageLayout';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { simInventoryQueries } from './Inventory/queries/simInventoryQueries';

export const SimInventoryTab = () => {
  const customFieldsProcessed = useCustomFieldsFiltersInitialization();

  return (
    <SimProfileTagProvider>
      <TableWithFiltersLayout filters={<SimFilters />}>
        <SuspenseLoadingView
          loadFallback={
            <ContentBox>
              <TableSkeleton showStartSkeleton showEndSkeleton numberOfRows={20} />
            </ContentBox>
          }
          queryKey={simInventoryQueries.all}
          forceLoadFallback={!customFieldsProcessed}
        >
          <SimInventoryTable />
        </SuspenseLoadingView>
      </TableWithFiltersLayout>
    </SimProfileTagProvider>
  );
};

export const SimInventory = () => {
  return (
    <SimProfilesPageLayout>
      <TabPanelWithErrorHandling name={'SIM'}>
        <SimInventoryFiltersURLParser>
          <SimInventoryTab />
        </SimInventoryFiltersURLParser>
      </TabPanelWithErrorHandling>
    </SimProfilesPageLayout>
  );
};
